import { render, staticRenderFns } from "./ObatForm.vue?vue&type=template&id=ed3b5298&"
import script from "./ObatForm.vue?vue&type=script&lang=js&"
export * from "./ObatForm.vue?vue&type=script&lang=js&"
import style0 from "./ObatForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports